// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blackList .el-pagination[data-v-b2253dbe] {\n  margin-top: 20px;\n  text-align: right;\n}\n.blackList .search[data-v-b2253dbe] {\n  margin: 20px 0;\n}\n", ""]);
// Exports
module.exports = exports;
